import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { AsmFeatureModule } from './asm/asm-feature.module'
import { CartBaseFeatureModule } from './cart/cart-base-feature.module'
import { CartImportExportFeatureModule } from './cart/cart-import-export-feature.module'
import { CartQuickOrderFeatureModule } from './cart/cart-quick-order-feature.module'
import { CartSavedCartFeatureModule } from './cart/cart-saved-cart-feature.module'
import { WishListFeatureModule } from './cart/wish-list-feature.module'
import { CheckoutFeatureModule } from './checkout/checkout-feature.module'
import { CustomerTicketingFeatureModule } from './customer-ticketing/customer-ticketing-feature.module'
import { DigitalPaymentsFeatureModule } from './digital-payments/digital-payments-feature.module'
import { EpdVisualizationFeatureModule } from './epd-visualization/epd-visualization-feature.module'
import { OrderFeatureModule } from './order/order-feature.module'
import { OrganizationAccountSummaryFeatureModule } from './organization/organization-account-summary-feature.module'
import { OrganizationAdministrationFeatureModule } from './organization/organization-administration-feature.module'
import { OrganizationOrderApprovalFeatureModule } from './organization/organization-order-approval-feature.module'
import { OrganizationUnitOrderFeatureModule } from './organization/organization-unit-order-feature.module'
import { OrganizationUserRegistrationFeatureModule } from './organization/organization-user-registration-feature.module'
import { PickupInStoreFeatureModule } from './pickup-in-store/pickup-in-store-feature.module'
import { ProductBulkPricingFeatureModule } from './product/product-bulk-pricing-feature.module'
import { ProductFutureStockFeatureModule } from './product/product-future-stock-feature.module'
import { ProductImageZoomFeatureModule } from './product/product-image-zoom-feature.module'
import { ProductVariantsFeatureModule } from './product/product-variants-feature.module'
import { QualtricsFeatureModule } from './qualtrics/qualtrics-feature.module'
import { S4omFeatureModule } from './s4om/s4om-feature.module'
import { SmartEditFeatureModule } from './smartedit/smart-edit-feature.module'
import { StoreFinderFeatureModule } from './storefinder/store-finder-feature.module'
import { PersonalizationFeatureModule } from './tracking/personalization-feature.module'
import { TagManagementFeatureModule } from './tracking/tag-management-feature.module'
import { UserFeatureModule } from './user/user-feature.module'
import { I18nModule, provideConfig } from '@spartacus/core'
import { BulkOrderModule } from '../../features/bulk-order/bulk-order.module'
import { OrderCheckoutModule } from '../../features/cart/checkout/checkout/order-checkout.module'
import { MiniCartModule } from '../../features/cart/mini-cart/mini-cart.module'
import { CustomProductRoutesModule } from '../../features/config/product-routes.module'
import { VsIconModule } from '../../features/config/vs-icon.module'
import { ContactformModule } from '../../features/contactform/contactform.module'
import { ContactusModule } from '../../features/contactus/contactus.module'
import { GuestTrackingModule } from '../../features/guest-tracking/guest-tracking.module'
import { LandingPagesModule } from '../../features/landing-pages/landing-pages.module'
import { MyFavouritesModule } from '../../features/my-favourites/my-favourites.module'
import { NavBarModule } from '../../features/nav-bar-links/nav-bar.module'
import { OrderTrackingModule } from '../../features/order-tracking/order-tracking.module'
import { PdpModule } from '../../features/pdp/pdp.module'
import { PlpModule } from '../../features/plp/plp.module'
import { QuoteCheckoutModule } from '../../features/quote/quote-checkout/quote-checkout.module'
import { QuoteReviewModule } from '../../features/quote/quote-review/quote-review.module'
import { RequestServiceQuoteModule } from '../../features/request-service-quote/request-service-quote.module'
import { MyProfileModule } from '../../features/user/my-profile/my-profile.module'
import { UserManagementModule } from '../../features/user/user-management/user-management.module'
import { WelcomePackageModule } from '../../features/welcome-package/welcome-package.module'
import { SpinnerOverlayModule } from '../../shared/components/spinner-overlay/spinner-overlay.module'
import { ClickOutsideModule } from '../../shared/directive/clickOutside/click-outside.module'
import { IndeterminateDirective } from '../../shared/directive/indeterminate.directive'
import { VsOutletModule } from '../../shared/outlet/outlet.module'
import { CartDetailsModule } from '../../features/cart/cart-details/cart-details.module'
import { SavedCartModule } from '../../features/cart/saved-cart/saved-cart.module'
import { QuoteModule } from '../../features/quote/quote.module'
import { TabParagraphContainerModule } from '../../features/pdp/tab-paragraph-container/tab-paragraph-container.module'
import { SearchBoxModule } from '../../features/search-box/search-box.module'
import { ProductFacetNavigationModule } from '../../features/plp/product-facet-navigation/product-facet-navigation.module'
import { CheckoutModule } from '../../features/cart/checkout/checkout.module'
import { SiteContextSelectorModule } from '../../shared/components/site-context-selector'
import { BreadcrumbModule } from '../../shared/components/breadcrumb/breadcrumb.module'
import { FooterNavigationModule } from '../../features/footer/footer-navigation.module'
import { LoginModule } from '../../features/user/login/login.module'
import { LoginFormModule } from '../../features/user/login-form/login-form.module'
import { PageNotFoundModule } from '../../features/page-not-found/page-not-found.module'
import { AppRoutingModule } from '../../app-routing.module'
import { FaqPageModule } from '../../features/faq-page/faq-page.module'
import { VS_LAUNCH_CALLER } from '../../features/config/dialog.config'
import { DIALOG_TYPE } from '@spartacus/storefront'
import { WarningDialogComponent } from '../../shared/dialog-box/warning-dialog/warning-dialog/warning-dialog.component'

@NgModule({
  declarations: [IndeterminateDirective],
  imports: [
    CommonModule,
    I18nModule,
    ClickOutsideModule,
    VsOutletModule,
    TabParagraphContainerModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    UserFeatureModule,
    ProductVariantsFeatureModule,
    ProductImageZoomFeatureModule,
    VsIconModule,
    SpinnerOverlayModule,
    CartDetailsModule,
    SavedCartModule,
    LoginModule,
    QuoteModule,
    CustomProductRoutesModule, // ---- not yet
    RequestServiceQuoteModule,
    PlpModule,
    NavBarModule,
    PdpModule,
    MyProfileModule,
    QuoteCheckoutModule,
    QuoteReviewModule,
    UserManagementModule,
    MiniCartModule,
    CheckoutModule,
    OrderCheckoutModule,
    SiteContextSelectorModule,
    MyFavouritesModule,
    WelcomePackageModule,
    BreadcrumbModule,
    LandingPagesModule,
    GuestTrackingModule,
    FooterNavigationModule,
    ContactusModule,
    ContactformModule,
    BulkOrderModule,
    AsmFeatureModule,
    OrderTrackingModule,
    LoginFormModule,
    CartBaseFeatureModule,
    CartSavedCartFeatureModule,
    WishListFeatureModule,
    CartQuickOrderFeatureModule,
    CartImportExportFeatureModule,
    OrderFeatureModule,
    CheckoutFeatureModule,
    PersonalizationFeatureModule,
    TagManagementFeatureModule,
    OrganizationAdministrationFeatureModule,
    OrganizationAccountSummaryFeatureModule,
    OrganizationUnitOrderFeatureModule,
    OrganizationUserRegistrationFeatureModule,
    OrganizationOrderApprovalFeatureModule,
    //ProductConfiguratorFeatureModule,
    StoreFinderFeatureModule,
    S4omFeatureModule,
    EpdVisualizationFeatureModule,
    DigitalPaymentsFeatureModule,
    CustomerTicketingFeatureModule,
    SmartEditFeatureModule,
    QualtricsFeatureModule,
    ProductFutureStockFeatureModule,
    ProductBulkPricingFeatureModule,
    PickupInStoreFeatureModule,
    PageNotFoundModule,
    AppRoutingModule,
    FaqPageModule,
  ],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.WARNING_DIALOG]: {
          inlineRoot: true,
          component: WarningDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  exports: [I18nModule],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class FeaturesModule {}
